import { Helmet } from 'react-helmet';
import AboutUs from '../components/AboutUs';
import WhyPrisuExperts from '../components/WhyPrisuExperts';
import Workflow from '../components/Workflow';

export default function About() {
  return (
    <>
      <Helmet>
        <title>About Us | The Prisu Experts</title>
        <meta
          name="description"
          content="Learn about The Prisu Experts, our mission, vision, and approach to delivering high-quality AI data solutions."
        />
      </Helmet>
      <AboutUs />
      <WhyPrisuExperts />
      <Workflow />
    </>
  );
}
